<template>
  <div id="app" class="bg-primary">
        <router-view id="router-view"/>
  </div>
</template>

<script>
export default {
}
</script>

<style>
#app {
  font-family: 'Montserrat', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
  min-height: 100vh;
}
h1 {
  font-weight: bold;
  margin-bottom: 20px;
}
</style>
